import { Component, OnInit } from "@angular/core";
import { async } from "@angular/core/testing";
import { Router } from "@angular/router";
import { CronometrotiempoService } from "src/app/services/cronometro/cronometrotiempo.service";

import { SocketioService } from "src/app/services/socketio.service";
import { UsuarioService } from "src/app/services/usuario/usuario.service";

@Component({
  selector: "app-sidebar",
  templateUrl: "./sidebar.component.html",
  styleUrls: ["./sidebar.component.css"],
})
export class SidebarComponent implements OnInit {
  title = "AngularMaterialGettingStarted";

  isMenuOpen = true;
  contentMargin = 240;
  nombreusuario = "";
  colorrepresentativo = "";
  alias = "";
  empresa = "";
  colorbot = "";
  inicializacronometro = 0;
  iniciaCronometraje = "";
  valor: any;
  nuevovalor = "";
  modoMtto = false;
  iconoconectadoaredconapesca = true;

  hor: number;
  min: number;
  seg: number;

  constructor(
    private router: Router,
    private login: UsuarioService,
    private socketService: SocketioService,
    private cronometrotiempoService: CronometrotiempoService
  ) {
    // const payload = {
    //   para: false
    // };
    // this.socketService.emit("sin_conexion", payload);
  }

  task: string[] = [
    "Clearning out my closet",
    "Take out trash bins",
    "Wash car",
    "Tank up the motorcycles",
    "Go for flight training",
  ];

  onToolbarMenuToggle() {
    console.log("On toolbar toggled", this.isMenuOpen);
    this.isMenuOpen = !this.isMenuOpen;

    if (!this.isMenuOpen) {
      this.contentMargin = 70;
    } else {
      this.contentMargin = 240;
    }
  }
  // sidenavEvents(str) {
  //   console.log(str);
  // }

  cerrarsesion() {
    localStorage.clear();
    this.router.navigate([""]);
  }

  ngOnInit() {
    const modomantenimiento = async () => {
      let modoto = localStorage.getItem("servidormtto");
      this.modoMtto = Boolean(JSON.parse(modoto));
    };

    // aqui asignaremos otra color a lel logo de sportfishing y parpadeando
    modomantenimiento();


     this.socketService.listen("sin_conexion").subscribe((data) => {
       let valor = JSON.stringify(data);
       let valor2 = JSON.parse(valor);

      this.iconoconectadoaredconapesca = valor2.data;
    });



    let nuevovalorcronometro = async () => {
      this.nuevovalor = localStorage.getItem("cronometrosider");

      this.consultaconexionesconapesca();
    };

    nuevovalorcronometro();

    // this.valor="11";
    this.nombreusuario = this.login.nombreempresa;
    this.colorrepresentativo = this.login.colorpersonal;
    this.alias = this.login.alias;
    this.empresa = this.login.nombreempresa;

    //  this.cronometrotiempoService.disparadorCronometro.subscribe(data=>{
    //   console.log ("*********************",data)
    //  })

    // this.socketService.listen('botsmx').subscribe( data => {
    //   const jsonstring = JSON.stringify(data);
    //   const obj = JSON.parse(jsonstring);
    //   this.colorbot = obj.color;
    //   alert ('recibi mensaje2');

    // });

    this.socketService.listen("modomantenimiento").subscribe((data) => {
      const jsonstring = JSON.stringify(data);
      const obj = JSON.parse(jsonstring);

      // tomamos le valor d el avariable
      // falso quore decir que ya salio dle modo mantenimienot
      // true que enttro a mantenimiento

      if (obj.valor =='true' ){
        localStorage.setItem(
          "servidormtto",
          "true"
        );
        this.modoMtto = true; 
  
      } else {
  
        localStorage.setItem(
          "servidormtto",
          "false"
        );
  
        this.modoMtto = false; 
      }
      
    });
  }

  consultaconexionesconapesca() {
    const mi_status = () => {
      const payload = {
        para: false,
      };
      this.socketService.emit("sin_conexion", payload);
    };

    setInterval(mi_status, 3000);
  }

  abreMovimiento() {
    // <li><a routerLink='../usuariospendientes'>demostracion</a></li>
    this.router.navigate(["../tabla"]);
    // this.router.navigate()
  }

  esRutaActiva(ruta: string) {
    return this.router.url.indexOf(ruta) !== -1;
  }

  abreBotadmin() {
    // <li><a routerLink='../usuariospendientes'>demostracion</a></li>
    this.router.navigate(["../botadmin"]);
    // this.router.navigate()
  }

  abrelistausuarios() {
    // <li><a routerLink='../usuariospendientes'>demostracion</a></li>
    this.router.navigate(["../usuariospendientes"]);
    // this.router.navigate()
  }

  abreinventarioslotes() {
    // <li><a routerLink='../usuariospendientes'>demostracion</a></li>
    this.router.navigate(["../inventariolote"]);
    // this.router.navigate()
  }

  abreusuariosportfishing() {
    this.router.navigate(["../usuariosportfishing"]);
  }

  abreUtilerias() {
    this.router.navigate(["../utilerias"]);
  }

  abrehistorial() {
    this.router.navigate(["../historial"]);
  }

  abregraficolineal() {
    // <li><a routerLink='../usuariospendientes'>demostracion</a></li>
    this.router.navigate(["../graficolineal"]);
    // this.router.navigate()
  }

  logout() {
    localStorage.clear();
    this.router.navigate([""]);
    // this.router.navigate(['/externalRedirect', { externalUrl: "https://www.sportfishingmx.com" }]);
    // window.open("https://www.sportfishingmx.com");
  }

  escuchandoconexionWeb() {
    const payload = {
      para: false,
    };
    this.socketService.emit("sin_conexion", payload);
  }
}
